import React, { useEffect, useRef } from 'react';
import './DubaiBuyVsRent.css';

const DubaiBuyVsRent = () => {
  const formContainerRef = useRef(null);

  useEffect(() => {
    // Add meta tags and tracking script to head
    
    // Create script element for Dubai calculator
    const script = document.createElement('script');
    script.src = 'https://tuomas-kivioja.kit.com/879c626762/index.js';
    script.async = false;
    script.setAttribute('data-uid', '879c626762');
    
    // Append script to the form container
    if (formContainerRef.current) {
      formContainerRef.current.appendChild(script);
    }
    
    // Cleanup function to remove all added elements when component unmounts
    return () => {
      if (document.querySelector('script[data-uid="879c626762"]')) {
        document.querySelector('script[data-uid="879c626762"]').remove();
      }
    };
  }, []);

  return (
    <div className="dubai-calculator-container">

      <div id="dubai-calculator-container" ref={formContainerRef}>
        {/* The calculator script will be appended here dynamically */}
      </div>
    </div>
  );
};

export default DubaiBuyVsRent;
